import { atom } from "recoil";
import { IWarning } from "types/common.d";

export const warningState = atom({
  key: "warningState",
  default: null as IWarning | null,
});
